export const DEFAULT_CODER_DOCS_LINK =
  'https://github.com/coder/backstage.cdr.dev/tree/main/plugins/coder';
